import "./condition.css"
import conditions_logo from "../../../assets/logo.svg";
import pdf_icon from "../../../assets/pdf_icon.png"
import conditions from "../../../assets/financial.png";
import React, {useEffect, useState} from "react";
import Accordion from 'react-bootstrap/Accordion';
import {Link, useNavigate} from "react-router-dom";
import {setConditionInfo, setFinder} from "../../../redux/conditions_store";
import {setPersonalData} from "../../../redux/personal_store";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import axios from "axios";

function Conditions({conditionInfo, setConditionInfo, appData, personalData, account}) {

    let backTo = '/experience'
    if (appData.account_type === 'custodial') backTo = '/experience'
    if (appData.account_type === 'joint') backTo = '/owner-info'
    if (appData.account_type === 'speciality') backTo = '/authorized-signers'

    const [activeTab, setActiveTab] = useState("0");
    const [foreignFinderData, setForeignFinderData] = useState(null);

    const {t} = useTranslation()
    const navigate = useNavigate()

    const [conditionErrors, setConditionErrors] = useState({
        customer: '',
        margin: '',
        option: '',
        taxPlayer: '',
        clear: '',
        agreew8: '',
        disclosure: '',
        privacy: '',
        finder: ''
    });

    useEffect(() => {
        setConditionInfo((prevConditionInfo) => ({
            ...prevConditionInfo,
            ExemptW9: appData.citizenship_status === "UsCitizen" && prevConditionInfo.taxPlayer,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appData.citizenship_status]);

    useEffect(() => {
        setConditionInfo({
            ...conditionInfo,
            clear: true,
            agreeConfirm: true,
            agreeEstatement: true,
            agreeProxy: true,
            agreePros: true,
            agreeEtax: true,
            privacy: true
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setConditionErrors({
            customer: '',
            margin: '',
            option: '',
            clear: '',
            agreew8: '',
            privacy: '',
            agreeConfirm: '',
            agreeEstatement: '',
            agreeProxy: '',
            agreePros: '',
            agreeEtax: '',
            finder: ''
        });

        let isValid = true;
        let firstErrorTab = null;

        const tabOrder = ["0", "1", "2", "3", "4", "5", "6", "7"];

        for (const tab of tabOrder) {
            if (tab === "0" && !conditionInfo.customer) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    customer: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "0";
                break;
            }

            if (tab === "1" && !conditionInfo.margin && account.accountType !== 'cashAcc') {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    margin: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "1";
                break;
            }

            if (tab === "2" && !conditionInfo.option && account.selectedOption !== 'level0') {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    option: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "2";
                break;
            }

            if (tab === "3" && !conditionInfo.agreew8 && appData.citizenship_status === "non_resident") {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    agreew8: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "3";
                break;
            }

            if (tab === "4" && !conditionInfo.clear) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    clear: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "4";
                break;
            }

            if (tab === "4" && !conditionInfo.clear) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    clear: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "4";
                break;
            }

            if (tab === "5") {
                const uncheckedCheckboxes = ["agreeConfirm", "agreeEstatement", "agreeProxy", "agreePros", "agreeEtax"]
                    .filter(checkbox => !conditionInfo[checkbox]);

                if (uncheckedCheckboxes.length > 0) {
                    uncheckedCheckboxes.forEach(checkbox => {
                        setConditionErrors(prevErrors => ({
                            ...prevErrors,
                            [checkbox]: t('errors.required_field'),
                        }));
                    });

                    isValid = false;
                    firstErrorTab = "5";
                    break;
                }
            }

            if (tab === "6" && !conditionInfo.privacy) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    privacy: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "6";
                break;
            }

            if (tab === "7" && !conditionInfo.finder && foreignFinderData) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    finder: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "7";
                break;
            }
        }

        if (isValid) {
            setConditionInfo(conditions);
            if (!appData.app_id) alert('Missing app id')

            try {
                await updateConditionsValues()
                navigate('/review')
            } catch (e) {
                console.log(e, "Failed to save")
            }
        } else {
            setActiveTab(firstErrorTab);
        }
    };

    useEffect(() => {
        fetchReferralsList();

        if (appData.AgreeForeignFinder) {
            setConditionInfo((prevConditionInfo) => ({
                ...prevConditionInfo,
                finder: true,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleInputChange = (e) => {
        const {name, checked} = e.target;

        setConditionInfo({...conditionInfo, [name]: !conditionInfo[name]});
        setConditionInfo((prevConditionInfo) => ({
            ...prevConditionInfo,
            [name]: checked,
            AgreeForeignFinder: checked ? "" : new Date().toISOString(),
        }));

        if (name === "customer") {
            setActiveTab(activeTab === "1" ? "" : account.accountType === 'cashAcc' && account.selectedOption === 'level0' ? '3' : account.accountType === 'cashAcc' ? '2' : '1');
        } else if (name === "margin") {
            setActiveTab(activeTab === "2" ? "" : account.selectedOption === 'level0' ? "3" : '2');
        } else if (name === "option") {
            setActiveTab(activeTab === "3" ? "" : "3");
        } else if (name === "taxPlayer" || name === "agreew8") {
            setActiveTab(activeTab === "4" ? "" : "4");
        } else if (name === "clear") {
            setActiveTab(activeTab === "5" ? "" : "5");
        } else if (name === "agreeConfirm") {
            setActiveTab(activeTab === "6" ? "" : "6")
        } else {
            setActiveTab(activeTab === "7" ? "" : "7");
        }
    };

    const getConditionsValues = () => {
        return {
            AgreeCust: conditionInfo.customer ? 'Y' : 'N',
            AgreeMargin: conditionInfo.margin ? 'Y' : 'N',
            AgreeOption: conditionInfo.option ? 'Y' : 'N',
            AddressVerified: conditionInfo.clear ? 'Y' : 'N',
            ExemptW9: conditionInfo.taxPlayer ? 'Y' : 'N',
            AgreeW8BEN: conditionInfo.agreew8 ? 'Y' : 'N',
            AgreeEConfirm: conditionInfo.agreeConfirm ? 'Y' : 'N',
            AgreeEstatement: conditionInfo.agreeEstatement ? 'Y' : 'N',
            AgreeEProxy: conditionInfo.agreeProxy ? 'Y' : 'N',
            AgreeEProspectus: conditionInfo.agreePros ? 'Y' : 'N',
            AgreeETax: conditionInfo.agreeEtax ? 'Y' : 'N',
            OwnerDisclosure: conditionInfo.disclosure ? 'Y' : 'N',
            AgreePrivacy: conditionInfo.privacy ? 'Y' : 'N',
            AgreeForeignFinder: conditionInfo.finder ? 'Y' : 'N'
        }
    };

    const fetchReferralsList = async () => {
        try {
            const URL = `${process.env.REACT_APP_API_URL}/api/accounts/getReferralsList`;
            const response = await axios.get(URL, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                },
            });

            const matchingFinder = response.data.find((finder) => finder.value.toLowerCase() === appData.hear_about_us.toLowerCase())

            if (matchingFinder && matchingFinder.foreignfinder) {
                setFinder(matchingFinder.value);
                setForeignFinderData(matchingFinder);
            }
        } catch (error) {
            console.error("Error fetching referrals list:", error);
        }
    };

    const updateConditionsValues = async () => {
        const URL = `${process.env.REACT_APP_API_URL}/api/accounts/step6/` + appData.app_id;
        const params = getConditionsValues();

        try {
            await axios.put(URL, params, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="conditions">
            <div className="conditions_left_side">
                <img src={conditions_logo} alt=""/>
                <img style={{paddingTop: "12%"}} src={conditions} alt=""/>
            </div>
            <div className="conditions_right_side">
                <Logout/>
                <p className="conditions_heading">{t('conditions.thanks')} {personalData.firstName} {personalData.lastName}. {t('conditions.terms_condition')}</p>
                <p className="conditions_heading_info">{t('conditions.financial_information')}</p>
                <form onSubmit={handleSubmit}>
                    <Accordion activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><Link to="/conditions"
                                                    style={{color: "unset"}}>{t('conditions.customer_agreement')}</Link></Accordion.Header>
                            <Accordion.Body>
                                <div style={{display: "flex", gap: "10px"}}>
                                    <input type="checkbox" className="agreement_check"
                                           name="customer"
                                           checked={conditionInfo.customer}
                                           onChange={handleInputChange}
                                    />

                                    <p className="agreement_check_text">{t('conditions.conditions_governing')} <a
                                        style={{color: "#262424"}}
                                        href="http://www.choicetrade.com/legal.php?page=custagree"
                                        target="_blank"
                                        rel="noreferrer">{t('conditions.customer_agreement')}.</a> {t('conditions.conditions_governing2')}
                                    </p>
                                </div>
                                {conditionErrors.customer &&
                                    <p className="conditions_info_error">{conditionErrors.customer}</p>}
                                <p className="customer_info">{t('conditions.arbitration_agreement')}</p>
                                <p className="fee_acknowledgement">{t('conditions.fee_acknowledgement')}</p>
                                <p className="fee_acknowledgement_text">{t('conditions.service_fee')}</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        {account.accountType !== 'cashAcc' && (
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <Link to="/conditions" style={{color: "unset"}}>
                                        {t('conditions.margin_agreement')}
                                    </Link>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div style={{display: "flex", gap: "10px", paddingBottom: "5%"}}>
                                        <input type="checkbox" className="agreement_check" name="margin"
                                               checked={conditionInfo.margin}
                                               onChange={handleInputChange}/>
                                        <p className="agreement_check_text">{t('conditions.margin_terms')}</p>
                                    </div>
                                    {conditionErrors.margin &&
                                        <p className="conditions_info_error">{conditionErrors.margin}</p>}
                                    <a href="http://www.choicetrade.com/legal.php?page=disclosures" target="_blank"
                                       className="agreement_text" rel="noreferrer">{t('conditions.margin_risk')}</a>
                                    <div>
                                        <a href="https://choicetrade-media.s3.amazonaws.com/forms/VLOX/MarginAgreement-VLOX.pdf"
                                           target="_blank" className="agreement_text"
                                           rel="noreferrer">{t('conditions.margin_agreement1')}</a>
                                    </div>
                                    <div>
                                        <a href="https://choicetrade-media.s3.amazonaws.com/forms/CURV/MarginAgreementCURV.pdf"
                                           className="agreement_text" target="_blank" rel="noreferrer">
                                            {t('conditions.margin_agreement2')}
                                        </a>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}
                        {account.selectedOption !== 'level0' && (
                            <Accordion.Item eventKey="2">
                                <Accordion.Header><Link to="/conditions"
                                                        style={{color: "unset"}}>{t('conditions.options_agreement')}</Link></Accordion.Header>
                                <Accordion.Body>
                                    <div style={{display: "flex", gap: "10px", paddingBottom: "5%"}}>
                                        <input type="checkbox"
                                               className="agreement_check"
                                               name="option"
                                               checked={conditionInfo.option}
                                               onChange={(event) => handleInputChange(event)}/>
                                        <p className="agreement_check_text">{t('conditions.any_material_change')}</p>
                                    </div>
                                    {conditionErrors.option &&
                                        <p className="conditions_info_error">{conditionErrors.option}</p>}
                                    <a href="https://www.choicetrade.com/legal.php?page=disclosures" target="_blank"
                                       className="agreement_text"
                                       rel="noreferrer">{t('conditions.option_disclosures')}</a>
                                    <div>
                                        <a href="https://choicetrade-media.s3.amazonaws.com/forms/ETC/optionct.pdf"
                                           target="_blank" className="agreement_text"
                                           rel="noreferrer">{t('conditions.options_supplement')}</a>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}
                        {appData.citizenship_status !== "non_resident" &&
                            <Accordion.Item eventKey="3">
                                <Accordion.Header><Link to="/conditions"
                                                        style={{color: "unset"}}>{t('conditions.taxpayer_id_number')}</Link></Accordion.Header>
                                <Accordion.Body>
                                    <div style={{display: "flex", gap: "10px", paddingBottom: "3%"}}>
                                        <input
                                            type="checkbox"
                                            className="agreement_check"
                                            name="taxPlayer"
                                            checked={conditionInfo.taxPlayer}
                                            onChange={(event) => handleInputChange(event)}
                                        />
                                        <p className="agreement_check_text">{t('conditions.notified_irs')}</p>
                                    </div>
                                    <div className="certify_text">
                                        <p>{t('conditions.penalty_of_perjury')}</p>
                                        <p>{t('conditions.number_1')}</p>
                                        <p>{t('conditions.number_2')}</p>
                                        <p>{t('conditions.number_3')}</p>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        }

                        {appData.citizenship_status === "non_resident" &&
                            <Accordion.Item eventKey="3">
                                <Accordion.Header><Link to="/conditions"
                                                        style={{color: "unset"}}>{t('conditions.agreew8_heading')}</Link></Accordion.Header>
                                <Accordion.Body>
                                    <div style={{
                                        display: "flex",
                                        gap: "10px",
                                        flexDirection: "column"
                                    }}>
                                        <div style={{display: "flex", gap: "10px"}}>
                                            <input
                                                type="checkbox"
                                                className="agreement_check"
                                                name="agreew8"
                                                checked={conditionInfo.agreew8}
                                                onChange={(event) => handleInputChange(event)}
                                            />
                                            <p className="agreement_check_text">{t('conditions.agreew8_text')}</p>
                                        </div>
                                        <p>
                                            <img src={pdf_icon} alt="" style={{width: "30px"}}/>
                                            <a href="https://choicetrade-media.s3.amazonaws.com/forms/fw8ben.pdf"
                                               target="_blank" rel="noreferrer" style={{color: "red"}}>
                                                {t('conditions.w8_form')}
                                            </a>
                                        </p>
                                    </div>
                                    {conditionErrors.agreew8 &&
                                        <p className="conditions_info_error">{conditionErrors.agreew8}</p>}
                                </Accordion.Body>
                            </Accordion.Item>
                        }

                        <Accordion.Item eventKey="4">
                            <Accordion.Header><Link to="/conditions"
                                                    style={{color: "unset"}}>{t('conditions.clearing_authorization')}</Link></Accordion.Header>
                            <Accordion.Body>
                                <div style={{display: "flex", gap: "10px"}}>
                                    <input type="checkbox" className="agreement_check"
                                           name="clear"
                                           checked={conditionInfo.clear}
                                           onChange={handleInputChange}/>
                                    <p className="agreement_check_text">{t('conditions.client_auth_condition')}</p>
                                </div>
                                {conditionErrors.clear &&
                                    <p className="conditions_info_error">{conditionErrors.clear}</p>}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="5">
                            <Accordion.Header><Link to="/conditions"
                                                    style={{color: "unset"}}>{t('experience.document_delivery')}</Link></Accordion.Header>
                            <Accordion.Body>
                                <p className="exp_doc_delivery_text">{t('experience.additional_fees')}</p>
                                <div className="exp_doc">
                                    <div>
                                        <div className="delivery_checks">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreeConfirm"
                                                checked={conditionInfo.agreeConfirm}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text">{t('experience.trade_conf_email')}</p>
                                        </div>
                                        {conditionErrors.agreeConfirm &&
                                            <p className="conditions_info_error">{conditionErrors.agreeConfirm}</p>}
                                    </div>
                                    <div>
                                        <div className="delivery_checks">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreeEstatement"
                                                checked={conditionInfo.agreeEstatement}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text">{t('experience.account_statement_email')}</p>
                                        </div>
                                        {conditionErrors.agreeEstatement &&
                                            <p className="conditions_info_error">{conditionErrors.agreeEstatement}</p>}
                                    </div>
                                    <div>
                                        <div className="delivery_checks">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreeProxy"
                                                checked={conditionInfo.agreeProxy}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text">{t('experience.proxy_statement_email')}</p>
                                        </div>
                                        {conditionErrors.agreeProxy &&
                                            <p className="conditions_info_error">{conditionErrors.agreeProxy}</p>}
                                    </div>

                                    <div>
                                        <div className="delivery_checks">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreePros"
                                                checked={conditionInfo.agreePros}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text">{t('experience.prospectuses_email')}</p>
                                        </div>
                                        {conditionErrors.agreePros &&
                                            <p className="conditions_info_error">{conditionErrors.agreePros}</p>}
                                    </div>
                                    <div>
                                        <div className="delivery_checks">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreeEtax"
                                                checked={conditionInfo.agreeEtax}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text">{t('experience.tax_document_email')}</p>
                                        </div>
                                        {conditionErrors.agreeEtax &&
                                            <p className="conditions_info_error">{conditionErrors.agreeEtax}</p>}
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="6">
                            <Accordion.Header><Link to="/conditions"
                                                    style={{color: "unset"}}>{t('conditions.privacy')}</Link></Accordion.Header>
                            <Accordion.Body>
                                <div className="owner_disclosure_parts">
                                    <input
                                        type="checkbox"
                                        className="owner_disclosure_check"
                                        name="disclosure"
                                        checked={conditionInfo.disclosure}
                                        onChange={(e) => handleInputChange(e)}
                                    />
                                    <p className="agreement_check_text">{t('affiliation.ownership_disclosed')}</p>
                                </div>
                                <div className="owner_disclosure_parts">
                                    <input
                                        type="checkbox"
                                        className="owner_disclosure_check"
                                        name="privacy"
                                        checked={conditionInfo.privacy}
                                        onChange={(e) => handleInputChange(e)}
                                    />
                                    <p className="owner_disclosure_text"
                                       style={{margin: "0"}}>{t('affiliation.privacy_and_policy')}
                                        <a target="_blank"
                                           style={{
                                               color: "#817676",
                                               textDecoration: "none"
                                           }}
                                           href="https://choicetrade.com/legal.php?page=privacy"
                                           rel="noreferrer">{t('affiliation.privacy_policy')}
                                        </a>
                                    </p>
                                </div>
                                {conditionErrors.privacy &&
                                    <p className="exp_info_error">{conditionErrors.privacy}</p>}
                            </Accordion.Body>
                        </Accordion.Item>

                        {foreignFinderData && (
                            <Accordion.Item eventKey="7">
                                <Accordion.Header><Link to="/conditions"
                                                        style={{color: "unset"}}>{t('conditions.finder_heading')}</Link></Accordion.Header>
                                <Accordion.Body>
                                    <div>
                                        <p className="finder_info">{t('conditions.finder_text1')}</p>
                                        <p className="finder_info">{t('conditions.finder_text2')}</p>
                                        <p className="finder_info">{t('conditions.finder_text3')}</p>
                                        <p className="finder_info">{t('conditions.finder_text4')} {foreignFinderData.hear_about} {t('conditions.finder_text5')}
                                        </p>
                                        {foreignFinderData.foreignfinder && (
                                            <p className="finder_info">{foreignFinderData.foreignfinder}</p>
                                        )}
                                        <div className="owner_disclosure_parts">
                                            <input
                                                type="checkbox"
                                                className="owner_disclosure_check"
                                                name="finder"
                                                checked={conditionInfo.finder}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text">{t('conditions.finder_text6')}</p>
                                        </div>
                                        {conditionErrors.finder &&
                                            <p className="exp_info_error">{conditionErrors.finder}</p>}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}
                    </Accordion>
                    <div className="conditions_btn">
                        <Link style={{textDecoration: "none"}} to={backTo}>
                            <button className="conditions_back_btn">{t('back_btn')}</button>
                        </Link>
                        <button className="conditions_continue_btn" type="submit">{t('next_btn')}</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    conditionInfo: state.conditionInfo,
    appData: state.appData,
    personalData: state.personalData,
    account: state.account
});

const mapDispatchToProps = {
    setConditionInfo,
    setPersonalData,
    setFinder
};

export default connect(mapStateToProps, mapDispatchToProps)(Conditions);